export default __webpack_public_path__ + "static/media/General's Chestplate of the Golden Sun.88e3c1a9.jpg";